module.exports = __webpack_public_path__ + "static/img/emqx-logo-enterprise.3b441e56.svg";